import { useNavigate } from "react-router-dom";

import ArrowBackIcon from '@mui/icons-material/ArrowBack';


function SubHeader({nav, display}) {
  const navigate = useNavigate();

  return (
     <div className="sub-header">
       <ArrowBackIcon 
          className="icon" 
          onClick={()=>navigate(nav)}
        />
        <h2>{display}</h2>
    </div>
  );
}


export default SubHeader;
